import React from 'react';
import noop from 'lodash/noop';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import type { Props } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const DevDetailDialogLoaderWithContainer = lazy(
	() => import(/* webpackChunkName: "async-dev-panel-details-loader" */ './index-old'),
	{ ssr: false },
);

const DevDetailsDialogLoaderAsyncNew = ({
	onCloseDevDetailDialog = noop,
	...props
}: Props): React.JSX.Element => (
	<Placeholder name="dev-detail-dialog-loader-with-container" fallback={<></>}>
		<DevDetailDialogLoaderWithContainer
			onCloseDevDetailDialog={onCloseDevDetailDialog}
			{...props}
		/>
	</Placeholder>
);

const DevDetailsDialogLoaderAsyncOld = (props: Props): React.JSX.Element => (
	<Placeholder name="dev-detail-dialog-loader-with-container" fallback={<></>}>
		<DevDetailDialogLoaderWithContainer {...props} />
	</Placeholder>
);

DevDetailsDialogLoaderAsyncOld.defaultProps = {
	onCloseDevDetailDialog: noop,
};

/**
 * @deprecated - Use the DevDetailsDialogLoader (sync) component instead (in /index.tsx).
 */
export const DevDetailsDialogLoaderAsync = componentWithFG(
	'jira_removing_defaultprops',
	DevDetailsDialogLoaderAsyncNew,
	DevDetailsDialogLoaderAsyncOld,
);

/**
 * @deprecated - Use the DevDetailsDialogLoader (sync) component instead (in /index.tsx).
 */
export default DevDetailsDialogLoaderAsync;
